/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {useEffect, useRef} from 'react';


export const useInterval = (callback, delay) => {
    delay = delay || 0

    const ref = useRef(null)
    useEffect(() => {ref.current = callback})

    useEffect(() => {
        const id = setInterval(() => ref?.current && ref.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
}
